const lessons = [
  {
    id: 1,
    header: "Diagnosis",
    content: "This is the content for lesson 1.",
    icon: "fas fa-stethoscope"
  },
  {
    id: 2,
    header: "Treatment",
    content: "This is the content for lesson 2.",
    icon: "fas fa-hospital"
  },
  {
    id: 3,
    header: "Emotional Support",
    content: "This is the content for lesson 3.",
    icon: "fas fa-heart"
  },
  {
    id: 4, 
    header: "Financial Support",
    content: "This is the content for lesson 4.",
    icon: "fas fa-dollar-sign"
  },
  {
    id: 5,
    header: "Life After",
    content: "This is the content for lesson 5.",
    icon: "fas fa-sun"
  }
];

export default lessons;